<template>
  <el-dialog
    title="配置停止计息日期"
    :visible.sync="dialogVisible"
    width="600px"
    class="setStopInterestDate"
    @close="close"
  >
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      label-width="105px"
    ></base-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ this.$t('receivablesManageList.button.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{
        this.$t('receivablesManageList.button.determine')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import { mapState } from 'vuex';
  import baseForm from '@/components/form/base-form';
  import API from '@/api/capitalCenter/moneyDraw';
  export default {
    components: {
      baseForm,
    },
    data() {
      return {
        dialogVisible: false,
        baseData: {
          id: null,
          customerCode: null,
          customerName: null,
          orderNo: null,
          stopInterestDate: null,
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      baseDataOptions() {
        return [
          {
            type: 'input',
            label: '客户',
            prop: 'customerName',
            span: 24,
            disabled: true,
          },
          {
            type: 'input',
            label: '订单',
            prop: 'orderNo',
            span: 24,
            disabled: true,
          },
          {
            type: 'date',
            label: '停止计息日期',
            prop: 'stopInterestDate',
            span: 24,
          },
        ];
      },
    },
    methods: {
      // 打开
      openDialog(val) {
        this.dialogVisible = true;
        this.baseData.customerCode = val.customerCode;
        this.baseData.customerName = val.customerName;
        this.baseData.orderNo = val.orderNo;
        this.getDetail();
      },
      getDetail() {
        this.loading.startLoading();
        this.$axios
          .post(API.QUERY_INTERESTSUMMARY, {
            customerCode: this.baseData.customerCode,
            customerName: this.baseData.customerName,
            orderNo: this.baseData.orderNo,
          })
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              if (res.data.data.length > 0) {
                Object.keys(this.baseData).map((item) => {
                  return (this.baseData[item] = res.data.data[0][item]);
                });
              }
            }
          });
      },
      // 关闭
      close() {
        this.dialogVisible = false;
        Object.keys(this.baseData).map((item) => {
          return (this.baseData[item] = null);
        });
      },
      // 保存
      async save() {
        let params = this.exportChildData();
        if (params) {
          this.loading.startLoading();
          this.$axios
            .post(API.SAVE_INTERESTSUMMARY, params)
            .then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.$message({ showClose: true, type: 'success', message: res.data.msg });
                this.close();
              }
            })
            .catch(() => {
              this.loading.endLoading();
              this.$message({ showClose: true, type: 'error', message: '服务错误！' });
            });
        }
      },
      // 返回数据
      exportChildData() {
        // 点击提交，走校验
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  ::v-deep.setStopInterestDate {
    // text-align: center;
    .el-dialog__body {
      padding: 30px 130px 12px 50px;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
</style>
